import React from "react"
import Paper from "@material-ui/core/Paper/index"
import Tabs from "@material-ui/core/Tabs/index"
import Tab from "@material-ui/core/Tab/index"
import About from "./AboutTab"
import Syllabus from "./SyllabusTab"
import Faqs from "./FaqsTab"
import { Grid, withStyles } from "@material-ui/core"
import { faqs, TeamMembersData } from "../../../shared/constants"
import TeamMembers from "../../Team/TeamMembers"

export class CourseDetailTabs extends React.Component {
  state = {
    tabValue: 0,
  }

  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  render() {
    const { tabValue } = this.state
    const {
      classes,
      details,
      courseDuration,
      level,
      onEnrollClick,
      enrollUrl,
    } = this.props
    const courseInstructors = new Set(details.instructors)
    const instructors = TeamMembersData.filter(
      member => courseInstructors.has(member.name),
    )
    const allFaqs = details.faqs ? [...details.faqs, ...faqs] : faqs

    return (
      <Grid container direction={"column"} alignItems={"center"}>
        <Grid item xs={12}>
          <Paper elevation={0} square>
            <Tabs
              value={tabValue}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleChange}
            >
              <Tab aria-label={"About"} label="About"/>
              <Tab aria-label={"Instructor"} label="Instructor"/>
              <Tab aria-label={"Syllabus"} label="Syllabus"/>
              <Tab aria-label={"FAQs"} label="FAQs"/>
            </Tabs>
          </Paper>
        </Grid>
        <Grid item xs={11} className={classes.tabContent}>
          {tabValue === 0 && (
            <About
              courseDuration={courseDuration}
              level={level}
              data={details.about}
            />
          )}
          {tabValue === 1 && <TeamMembers members={instructors}/>}
          {tabValue === 2 && (
            <Syllabus
              data={details.syllabus}
              onEnrollClick={onEnrollClick}
              enrollUrl={enrollUrl}
            />
          )}
          {tabValue === 3 && <Faqs items={allFaqs}/>}
        </Grid>
      </Grid>
    )
  }
}

const styles = theme => ({
  tabContent: {
    paddingTop: theme.spacing(6),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(3),
    },
  },
})

export default withStyles(styles)(CourseDetailTabs)
